import type { BannerItem } from '@/types'
import Link from 'next/link'
import { useRef, type FC } from 'react'
import type { Settings } from 'react-slick'
import Slider from 'react-slick'
import ImageOptimize from '../ImageOptimize'

interface Props {
  sliders?: Array<BannerItem>
  systemConfig?: {
    imagePlaceholder?: string
  }
}

export const RegisterSlider: FC<Props> = ({ sliders, systemConfig }: Props) => {
  const sliderSettings: Settings = {
    autoplay: true,
    dots: false,
    autoplaySpeed: 5000,
    speed: 800,
    arrows: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
  }
  const slider = useRef<Slider>(null)

  if (!sliders || sliders.length === 0) {
    return (
      <Link href='/login'>
        <ImageOptimize
          quality={100}
          className='max-h-[50rem] w-full object-cover'
          src={
            systemConfig?.imagePlaceholder ||
            process.env.NEXT_PUBLIC_IMAGE_PLACEHOLDER ||
            ''
          }
          alt=''
          width={538}
          height={400}
        />
      </Link>
    )
  } else if (sliders.length < 2) {
    return (
      <Link href={sliders[0].link || '/'} key={0}>
        <ImageOptimize
          className='h-full w-[90%] rounded-xl object-cover'
          src={sliders[0].image}
          alt={sliders[0].title}
          quality={100}
          width={538}
          height={400}
        />
      </Link>
    )
  } else {
    return (
      <div className={'relative'}>
        <Slider ref={slider} {...sliderSettings} className=''>
          {sliders.map((slider: BannerItem, index: number) => (
            <Link href={slider.link || '/'} key={index}>
              <ImageOptimize
                className='h-full w-[90%] rounded-xl object-cover'
                src={slider.image}
                alt={slider.title}
                quality={100}
                width={538}
                height={400}
              />
            </Link>
          ))}
        </Slider>
      </div>
    )
  }
}

export default RegisterSlider
